import { useQuery } from '@tanstack/react-query';
import { getBtc15FittedModels } from '../lib/apiClient';

// The server-side refit runs at most once a day (btc15-model-refit-scheduled.ts),
// so there's no value in polling anywhere near as often as the main
// predictor query does.
const STALE_TIME_MS = 10 * 60_000;

export function useBtc15FittedModels() {
  return useQuery({
    queryKey: ['btc15-fitted-models'],
    queryFn: getBtc15FittedModels,
    staleTime: STALE_TIME_MS,
    refetchInterval: STALE_TIME_MS,
  });
}
